// extracted by mini-css-extract-plugin
export default {"tabs":"TabsList_tabs__NszIh","carousel":"TabsList_carousel__eaTjX","arrow":"TabsList_arrow__71svK","arrowLeft":"TabsList_arrowLeft__oX5pN","arrowRight":"TabsList_arrowRight__Zz05v"};